import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs2 from "./page_us/Solution-US-2/SectionUs2.js";
import { useEffect } from "react";




const PlafondsMursTendus = () =>{
    useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Éclairage Architectural Maroc | LED Design & Lighting – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Éclairage architectural LED au Maroc avec UNIK SYSTEM : conception lighting design pour plafonds, façades et espaces professionnels. Ambiance moderne et performance lumineuse."
  );

  setMeta(
    "keywords",
    "eclairage architectural maroc, lighting design maroc, eclairage LED maroc, eclairage facade maroc, eclairage plafond LED maroc, lighting design casablanca, eclairage moderne maroc, UNIK SYSTEM light"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/eclairage-architectural-maroc"
  );

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Éclairage Architectural Maroc – LED Design | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Lighting design LED pour plafonds, façades et espaces professionnels au Maroc."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/13Fa%C3%A7ade%20architecturale%20moderne%20de%20la%20gare%20Rabat%20Agdal%20avec%20habillage%20et%20%C3%A9clairage%20int%C3%A9gr%C3%A9.c11f0b1de6ec2589cf76.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/eclairage-architectural-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Éclairage Architectural Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solutions LED design et lighting moderne pour sublimer vos espaces."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/13Fa%C3%A7ade%20architecturale%20moderne%20de%20la%20gare%20Rabat%20Agdal%20avec%20habillage%20et%20%C3%A9clairage%20int%C3%A9gr%C3%A9.c11f0b1de6ec2589cf76.webp"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en éclairage architectural LED et lighting design au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Lighting Design",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Éclairage LED Plafond"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Éclairage Façade Architecturale"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-light");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-light";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi l’éclairage architectural ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est une conception lumineuse qui met en valeur l’architecture d’un espace avec des solutions LED modernes."
        }
      },
      {
        "@type": "Question",
        name: "Quels espaces peuvent être éclairés ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Maisons, bureaux, hôtels, commerces et façades extérieures."
        }
      },
      {
        "@type": "Question",
        name: "Pourquoi choisir LED ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Les LED offrent économie d’énergie, durabilité et un rendu lumineux performant."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-light");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-light";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs2/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;